import { apiPost } from "@app/utils/http";

export default class CaptchaService {
    static verify(captcha: string): Promise<Response> {
        return apiPost(`@api/verifyCaptcha/`, { captcha });
    }
}